import { useRef } from 'react';

import { debounce } from '@web/common/utils/debounce';

import { ToggleHeaderTabsType } from '../../types';

const TOGGLE_OFFSET = 150;
const ALWAYS_VISIBLE_OFFSET = 50;

type ScrollDirectionType = 'forward' | 'backward';

type OnScrollProps = {
  scrollDirection: ScrollDirectionType;
  scrollOffset: number;
  scrollUpdateWasRequested: boolean;
};

type OnScrollType = (props: OnScrollProps) => void;

type Props = {
  toggleHeaderTabs: ToggleHeaderTabsType;
};

type ScheduleScrollType = {
  onScroll: OnScrollType;
};

export default function useScheduleScroll({ toggleHeaderTabs }: Props): ScheduleScrollType {
  const togglePositionRef = useRef(0);

  const shouldToggle = (scrollOffset: number, direction: ScrollDirectionType): boolean => {
    return (
      (scrollOffset < ALWAYS_VISIBLE_OFFSET && direction === 'backward') ||
      Math.abs(togglePositionRef.current - scrollOffset) > TOGGLE_OFFSET
    );
  };

  const onScroll: OnScrollType = ({ scrollDirection, scrollOffset, scrollUpdateWasRequested }) => {
    if (scrollUpdateWasRequested) {
      return;
    }

    if (shouldToggle(scrollOffset, scrollDirection)) {
      toggleHeaderTabs({ isHidden: scrollDirection === 'forward' });
      togglePositionRef.current = scrollOffset;
    }
  };

  const onScrollDebounced = useRef(debounce(onScroll, 100)).current;

  return {
    onScroll: onScrollDebounced,
  };
}
